export const getIndexedDb = (dbName: string, dbVersion: number): Promise<IDBDatabase> => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(dbName, dbVersion)
        request.onsuccess = () => resolve(request.result)
        request.onerror = () => reject(request.error?.message)
    })
}
